import { classNames } from '@/utils/classNames';
import { Link } from 'react-router-dom';
import styles from './AdminLogin.module.css';
import { useAdminLogin } from './useAdminLogin';

export const AdminLogin = () => {
  const { values, error, isLoading, handleChange, handleSubmit } = useAdminLogin();
  const inputClassName = classNames(styles.input, error && styles.inputError);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Admin Login</h1>
        <p className={styles.subtitle}>Sign in to access the admin panel</p>

        <form
          className={styles.form}
          onSubmit={(event) => {
            void handleSubmit(event);
          }}
        >
          {error && <div className={styles.error}>{error}</div>}

          <div className={styles.inputGroup}>
            <label htmlFor="login" className={styles.label}>
              Login
            </label>
            <input
              id="login"
              name="login"
              type="text"
              className={inputClassName}
              placeholder="admin"
              value={values.login}
              onChange={handleChange}
              autoComplete="username"
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              className={inputClassName}
              placeholder="Enter your password"
              value={values.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className={styles.submitButton} disabled={isLoading}>
            {isLoading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <Link to="/" className={styles.backLink}>
          Back to homepage
        </Link>
      </div>
    </div>
  );
};
